import type { TemplateSaveSettlement } from './saveRequest';

type GraphQLErrorLike = {
  message?: string;
  extensions?: { code?: unknown };
};

export function settlementFromSaveFailure(error: unknown): TemplateSaveSettlement {
  const graphQLErrors = (error as { graphQLErrors?: GraphQLErrorLike[] })?.graphQLErrors;
  const first = graphQLErrors?.[0];
  if (first?.extensions?.code === 'CONFLICT') {
    return {
      status: 'stale',
      message:
        first.message ?? 'The template was saved elsewhere. Read the document again before saving.',
    };
  }
  return { status: 'failed', message: 'Something went really wrong' };
}
